var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"cky-banner-element",class:{
    'btn -anchor-link': _vm.location === 'footer',
    'btn -main': _vm.location === 'account-data',
    'btn -dark': _vm.location === 'embed',
  }},[_vm._v("\n  Cookie Preferences\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }